import React, { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

interface GradientBackgroundProps {
    children?: ReactNode;
}

const GradientBackground = ({ children }: GradientBackgroundProps) => {
    return (
        <View style={styles.container}>
            <View style={styles.content}>{children}</View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    content: {
        flex: 1,
        alignItems: 'center',
    },
});

export default GradientBackground;
